// analytics.js
import ReactGA from 'react-ga4';

// Initialize Google Analytics with your Measurement ID
export const initializeAnalytics = () => {
  ReactGA.initialize('G-F7YBF6FG2M', { debug_mode: true });
};

// Track page views
export const trackPageView = (page) => {
  ReactGA.send({ hitType: 'pageview', page });
};

// Track custom events
export const trackEvent = (category, action, label, value) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value,
  });
};


export const trackFileDownload = (fileName) => {
    ReactGA.event({
      category: 'File Download',
      action: 'Download',
      label: fileName,
    });
  };

  export const trackError = (errorName, errorDetails) => {
    ReactGA.event('Error', {
      category: 'App Error',
      action: errorName,
      label: errorDetails,
    });
}

// Set user properties (using first name only if no user ID is available)
export const setUserProperties = (userName) => {
    ReactGA.set({
      user_name: userName,
      'dimension1': userName, // Send the user's first name
    });
  };